import React from 'react';

import PropTypes from 'prop-types';

import Dropdown from 'common/Dropdown';
import CheckboxInput from 'common/inputs/CheckboxInput';
import RadioButtonGroup from 'common/inputs/RadioButtonGroup';

import 'css/components/subdomain/admin/AdminHubspotSettings/_AdminHubspotSpend.scss';

const SpendOptions = [
  { name: 'mrr', render: 'MRR' },
  { name: 'arr', render: 'ARR' },
];

const AdminHubspotSpend = ({
  accountFields,
  onChange,
  syncSpend,
  syncSpendField,
  syncSpendTerm,
}) => {
  return (
    <div className="adminHubspotSpend">
      <CheckboxInput
        className="spendCheckbox"
        defaultChecked={syncSpend}
        label="Sync MRR/ARR"
        onChange={(sync) =>
          onChange({
            sync,
            spendTerm: sync ? SpendOptions[0].name : null, // Set default field to the first option
          })
        }
      />
      {syncSpend && accountFields.length === 0 ? (
        <div className="formContents">Please select at least one account field</div>
      ) : null}
      {syncSpend && accountFields.length > 0 ? (
        <div className="formContents">
          <label>Which field in Hubspot should we sync as MRR/ARR into Canny?</label>
          <Dropdown
            className="fieldDropdown"
            defaultSelectedName={syncSpendField}
            dropdownClassName="adminHubspotSpendDropdown"
            onChange={(field) => onChange({ spendField: field })}
            options={accountFields.map((field) => ({
              name: field.name,
              render: (
                <>
                  {field.label} <span className="fieldName">({field.name})</span>
                </>
              ),
            }))}
          />
          <label>
            Is this field MRR (monthly recurring revenue) or ARR (annual recurring revenue)?
          </label>
          <RadioButtonGroup
            buttons={SpendOptions}
            defaultSelectedName={syncSpendTerm}
            onChange={(term) => onChange({ spendTerm: term.name })}
          />
        </div>
      ) : null}
    </div>
  );
};

AdminHubspotSpend.propTypes = {
  accountFields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func,
  syncSpend: PropTypes.bool,
  syncSpendField: PropTypes.string,
  syncSpendTerm: PropTypes.oneOf(['mrr', 'arr']),
};

export default AdminHubspotSpend;
